import { Trans } from '@lingui/react/macro';
import React from 'react';
import { Badge } from '@ygtechnologies/rubus-ui';
import theme from './HomePage.module.scss';

export const DeadlinePill = ({
    daysLeft,
    color,
}: {
    daysLeft: number;
    color: 'success' | 'warning' | 'info' | 'danger';
}) => {
    let text = <Trans>{daysLeft} days left</Trans>;
    if (daysLeft < 0) text = <Trans>Expired</Trans>;
    if (daysLeft === 0) text = <Trans>Today</Trans>;
    if (daysLeft === 1) text = <Trans>1 day left</Trans>;

    return (
        <Badge variant={color} className={theme.deadlinePill} appearance="subtle">
            {text}
        </Badge>
    );
};
